import React from 'react';
import { colors, components, typography } from '@peachjar/components';
import { css } from 'react-emotion';

import { getDiscountedPrice } from '../../../../../../_shared/utils/utils';

const { bold } = typography;
const { slate } = colors;
const { ButtonPrimaryLarge } = components.Buttons;

const styles = {
  wrapper: css({
    height: '291px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  }),
  totalPrice: css({
    fontSize: '34px',
    borderBottom: '2px solid #d9d9d9',
    width: '120px',
    fontWeight: 600,
    textAlign: 'center',
  }),
  subText: css({
    fontSize: '14px',
    color: slate,
  }),
};

// FIXME redux-form qk
const TotalCost = ({
  discountRate,
  pricePerSchool,
  numberOfSchools,
  totalCost,
  onGetStarted,
}) => (
  <div className={styles.wrapper}>
    {
      Number(numberOfSchools) > 0 && Number(totalCost) === 0 ?
        <p className={bold}>Get started today for free!</p> :
        <div>
          <p className={bold}>One-time fee</p>
          <p className={styles.totalPrice} data-testid="info-totalCost">
            {numberOfSchools && Number(numberOfSchools > 0) ? `$${totalCost}` : '$'}
          </p>
        </div>
    }
    
    {!pricePerSchool ||
      (pricePerSchool > 0 && (
        <p className={styles.subText} data-testid="info-pricePerSchool">
          ${discountRate
            ? getDiscountedPrice(discountRate, pricePerSchool)
            : pricePerSchool}/school
        </p>
      ))}
    <ButtonPrimaryLarge
      onClick={onGetStarted}
      className="registration-button"
      disabled={numberOfSchools < 1 || !numberOfSchools}
      data-testid="click-getStarted"
    >
      Get Started
    </ButtonPrimaryLarge>
  </div>
);

export default TotalCost;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/TotalCost.jsx